import type { PublicAppConfig } from "@mk/shared";
import { api } from "./api.ts";

const EMPTY_CONFIG: PublicAppConfig = {
  googleClientId: null,
  supportUrl: null,
  supportInPlay: false,
  adsEnabled: false,
  liveAdsEnabled: false,
  purchasesEnabled: false,
};

let configPromise: Promise<PublicAppConfig> | null = null;

/** Secret içermeyen sunucu özellik ayarlarını bir kez yükler. */
export function loadAppConfig(): Promise<PublicAppConfig> {
  configPromise ??= api<PublicAppConfig>("/api/auth/config").catch(() => EMPTY_CONFIG);
  return configPromise;
}
